module.exports = __webpack_public_path__ + "img/no-connection.2d8648f4.png";